import { graphql, useFragment } from "react-relay";
import { OrgStoreWorkspaceBreadcrumbs_store$key } from "./__generated__/OrgStoreWorkspaceBreadcrumbs_store.graphql";
import { AHIcon, AHText } from "arkh";
import React from "react";
import { OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store$key } from "./__generated__/OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store.graphql";

export function OrgStoreWorkspaceBreadcrumbs(props: {
  store: OrgStoreWorkspaceBreadcrumbs_store$key;
}) {
  const store = useFragment(
    graphql`
      fragment OrgStoreWorkspaceBreadcrumbs_store on Store
      @argumentDefinitions(currentWorkspaceId: { type: "ID" }) {
        workspaceBreadcrumbs(
          belowWorkspaceId: $currentWorkspaceId
          includeExternalId: true
        )
      }
    `,
    props.store
  );

  if (store.workspaceBreadcrumbs.length === 0) {
    return null;
  }
  return (
    <AHText
      spaceBottom="xxsmall"
      type="detail"
      color="darkText"
      numberOfLines={1}
    >
      {store.workspaceBreadcrumbs.map((v, i, arr) => (
        <React.Fragment key={i}>
          <AHText
            selectable={false}
            type="detail"
            color="darkText"
            numberOfLines={1}
          >
            {v}
          </AHText>
          {arr.length !== i + 1 ? (
            <AHIcon
              spaceHorizontal="xxsmall"
              size="xxsmall"
              color="washedText"
              type="chevron-right"
            />
          ) : null}
        </React.Fragment>
      ))}
    </AHText>
  );
}

export function OrgStoreWorkspaceBreadcrumbsWithoutExternalId(props: {
  store: OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store$key;
}) {
  const store = useFragment(
    graphql`
      fragment OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store on Store
      @argumentDefinitions(currentWorkspaceId: { type: "ID" }) {
        workspaceBreadcrumbs(
          belowWorkspaceId: $currentWorkspaceId
          includeExternalId: false
        )
      }
    `,
    props.store
  );

  if (store.workspaceBreadcrumbs.length === 0) {
    return null;
  }
  return (
    <AHText
      spaceBottom="xxsmall"
      type="detail"
      color="darkText"
      numberOfLines={1}
    >
      {store.workspaceBreadcrumbs.map((v, i, arr) => (
        <React.Fragment key={i}>
          <AHText
            selectable={false}
            type="detail"
            color="darkText"
            numberOfLines={1}
          >
            {v}
          </AHText>
          {arr.length !== i + 1 ? (
            <AHIcon
              spaceHorizontal="xxsmall"
              size="xxsmall"
              color="washedText"
              type="chevron-right"
            />
          ) : null}
        </React.Fragment>
      ))}
    </AHText>
  );
}
